@if (!isExternal) {
    <div class="select-box">
        <!-- <mat-card>
    <mat-card-content> -->
        <!-- <mat-form-field>
      <mat-label>{{'Property.Properties' |translate}}</mat-label>
      <mat-select [(value)]="selectedProperties" multiple>
        <mat-option *ngFor="let property of unassignedProperties" [value]="property.name">
          {{property.display}}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
        <mat-form-field>
            <mat-label>{{ 'Property.Properties' | translate }}</mat-label>
            <input #propertyInput type="text" matInput [matAutocomplete]="auto" [formControl]="propertyListControl" (focusin)="propertyListControl.setValue('')" />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" hideSingleSelectionIndicator="true">
                @for (property of propertyList | async; track property) {
                    <mat-option [value]="property.name">
                        <mat-checkbox class="accent-button" (click)="$event.stopPropagation()" (change)="toggleSelection(property)" [checked]="property.isSelected">
                            {{ property.display }}
                        </mat-checkbox>
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
        <!-- <mat-form-field style="width: 230px;" *ngIf="selectedProperty.includes('customProperty')">
      <input matInput [(ngModel)]="customPropertyName" [ngModelOptions]="{standalone: true}" placeholder="{{'Property.CustomPropertyName' |translate}}">
    </mat-form-field> -->
        <!--  && customPropertyName === '' -->
        <button
            [disabled]="selectedProperties.length <= 0 || selectedProperties.includes('customProperty')"
            mat-icon-button
            type="button"
            class="accent-button"
            matTooltip="{{ 'Property.AddProperty' | translate }}"
            (click)="addProperty(selectedProperties)">
            <mat-icon>add_circle</mat-icon>
        </button>
        <!-- </mat-card-content>
</mat-card> -->
    </div>
}

<div class="properties-box" [formGroup]="propertiesForm">
    @if (propertiesForm !== undefined) {
        <div formArrayName="propertiesGroup">
            <!-- <mat-card>
      <mat-card-content *ngIf="propertiesForm"> -->
            <mat-form-field>
                <mat-label>{{ 'Property.PropertiesFilterLabel' | translate }}</mat-label>
                <input
                    autocomplete="off"
                    class="primary-button"
                    placeholder="{{ 'Property.FilterLabel' | translate }}"
                    class="search-input"
                    #search
                    matInput
                    type="text"
                    [(ngModel)]="searchProperty"
                    [ngModelOptions]="{ standalone: true }" />
                @if (search.value.length > 0) {
                    <button matSuffix mat-icon-button class="primary-button" (click)="resetSearch()">
                        <mat-icon>close</mat-icon>
                    </button>
                }
                @if (search.value.length < 1) {
                    <mat-icon class="primary-button" matSuffix>search</mat-icon>
                }
            </mat-form-field>
            @for (property of propertiesForm.get('propertiesGroup')['controls'] | formArrayFilterPipe: searchProperty; track property; let i = $index) {
                <div class="property">
                    <div class="property-container" [formGroupName]="i">
                        <!-- <div>
                <mat-form-field>
                  <input matInput placeholder="{{getPropertyTranslate(property['controls'].name.value)}}" (change)="onChanges()" formControlName="value">
                </mat-form-field>
              </div> -->
                        <div class="property-type">
                            @if (property.value.type === 'Number') {
                                <mat-form-field>
                                    <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                                    <input matInput type="number" (input)="onChanges()" formControlName="value" />
                                </mat-form-field>
                            }
                        </div>
                        <div class="property-type">
                            @if (property.value.type === 'Text') {
                                <mat-form-field>
                                    <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                                    <input matInput type="text" (input)="onChanges()" [errorStateMatcher]="matcher" formControlName="value" />
                                </mat-form-field>
                            }
                        </div>
                        <div class="property-type">
                            @if (property.value.type === 'List' || property.value.type === 'MList') {
                                <mat-form-field>
                                    <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                                    <mat-select formControlName="value" [multiple]="property.value.type === 'MList'" (selectionChange)="onChanges()">
                                        @for (listValue of property.value.values; track listValue) {
                                            <mat-option [value]="listValue">
                                                {{ listValue }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }
                        </div>
                        <div class="property-type">
                            @if (property.value.type === 'Date') {
                                <!-- <mat-form-field>
                                    <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                                    <input matInput type="date" (change)="onChanges()" formControlName="value" />
                                </mat-form-field> -->
                                <mat-form-field>
                                    <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                                    <input matInput [matDatepicker]="datepicker" (dateChange)="onChanges()" formControlName="value" />
                                    <mat-datepicker-toggle class="accent-button" matSuffix [for]="datepicker"></mat-datepicker-toggle>
                                    <mat-datepicker #datepicker disabled="false"></mat-datepicker>
                                </mat-form-field>
                            }
                        </div>
                        <div class="property-type">
                            @if (property.value.type === 'Datetime') {
                                <!-- <mat-form-field>
                                    <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                                    <input matInput type="datetime-local" (change)="onChanges()" formControlName="value" />
                                </mat-form-field> -->

                                <mat-form-field>
                                    <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                                    <input matInput [ngxMatDatetimePicker]="datetimepicker" (dateChange)="onChanges()" formControlName="value" />
                                    <mat-datepicker-toggle matSuffix class="accent-button" [for]="datetimepicker"></mat-datepicker-toggle>
                                    <ngx-mat-datetime-picker #datetimepicker disabled="false"></ngx-mat-datetime-picker>
                                </mat-form-field>
                            }
                        </div>
                        <div class="property-type">
                            @if (property.value.type === 'Time') {
                                <mat-form-field>
                                    <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                                    <input matInput type="time" (change)="onChanges()" formControlName="value" />
                                </mat-form-field>
                            }
                        </div>
                        @if (property.value.type === 'Check') {
                            <div class="property-type">
                                <mat-checkbox class="accent-button" formControlName="value" (change)="onChanges()">
                                    {{ getPropertyTranslate(property['controls'].name.value) }}
                                </mat-checkbox>
                            </div>
                        }
                        <div class="property-type">
                            @if (property.value.type === 'Range') {
                                <mat-form-field>
                                    <span matPrefix>[{{ property.value.values[0] }}]&nbsp;&nbsp;</span>
                                    <input
                                        matInput
                                        type="number"
                                        placeholder="{{ getPropertyTranslate(property['controls'].name.value) }}"
                                        (input)="onChanges()"
                                        [min]="property.value.values[0]"
                                        [max]="property.value.values[1]"
                                        formControlName="value" />
                                    <span matSuffix>&nbsp;&nbsp;[{{ property.value.values[1] }}]</span>
                                </mat-form-field>
                            }
                        </div>
                        <div>
                            @if (!isExternal) {
                                <mat-form-field>
                                    <mat-label>{{ 'Property.ScopePlaceholder' | translate }}</mat-label>
                                    <input matInput value="{{ 'Property.Scope' + property['controls'].scope.value | translate }}" [disabled]="true" readonly />
                                </mat-form-field>
                            }
                        </div>
                        <div class="property-readonly">
                            @if (!isExternal) {
                                <mat-checkbox class="primary-button" formControlName="readonly">{{ 'Property.Readonly' | translate }}</mat-checkbox>
                            }
                        </div>
                        <div class="property-legacyable">
                            @if (!isProfile && !isExternal) {
                                <mat-checkbox class="primary-button" formControlName="legacyable">{{ 'Property.Legacyable' | translate }}</mat-checkbox>
                            }
                        </div>
                        <div class="property-legacy">
                            @if (!isExternal) {
                                <mat-checkbox class="primary-button" formControlName="legacy">{{ 'Property.Legacy' | translate }}</mat-checkbox>
                            }
                        </div>
                        @if (!isExternal) {
                            <button
                                mat-icon-button
                                type="button"
                                matTooltip="{{ 'Property.DeleteProperty' | translate }}"
                                [disabled]="isProfile && property['controls'].scope.value === managedScope"
                                (click)="deleteProperty(property.value.name, i)"
                                class="primary-button">
                                <mat-icon>disabled_by_default</mat-icon>
                            </button>
                        }
                    </div>
                </div>
            }
            <!-- </mat-card-content>
          </mat-card> -->
        </div>
    }
</div>
